import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface DashboardSearchState {
  searchTerm: string;
}

const initialState: DashboardSearchState = {
  searchTerm: '',
};

const dashboardSearchSlice = createSlice({
  name: 'dashboardSearch',
  initialState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
  },
});
export const { setSearchTerm } = dashboardSearchSlice.actions;
export default dashboardSearchSlice.reducer;
